(function(window, document, undefined){
    const headerSearch = document.getElementById('headerSearch');
    
    if (headerSearch && window.innerWidth > 1024) {
        const minChars=3;
        const input = headerSearch.querySelector('input');
        const searchHints = headerSearch.querySelector('#searchHints');
        let phrase;
        const url='/search-autocomplete.php';
        
        const products = {
            productList: {},
            categoryList: {},
            producerList: {},
            hint: ''
        };
        
        const producers = {
            productList: {},
            categoryList: {},
            producerList: {},
            hint: ''
        };
        
        const categories = {
            productList: {},
            categoryList: {},
            producerList: {},
            hint: ''
        };
        
        const renderList=()=>{
            let cText=`
            <div class="header-serach__hints-category">
                <span class="header-serach__hints-heading">${input.dataset.categories}</span>
                <ul>
                ` ;
            for(let i=0; i<categories.categoryList.length; i++){ 
                cText += `<li class="search-category"><a href="/search-redirect.php?id=${categories.categoryList[i].hash}">${categories.categoryList[i].name}</a></li>`;
                if(i==5)break;
            }
            cText += `
                </ul>
            </div>`;
            
            let mText=`
                <div class="header-serach__hints-brand">
                <span class="header-serach__hints-heading">${input.dataset.producers}</span>
                <ul>
            `;
            for(let i=0; i<producers.producerList.length; i++){ 
                mText += `<li class="search-brand"><a href="/search-redirect.php?id=${producers.producerList[i].hash}">${producers.producerList[i].name}</a></li>`;
                if(i==5)break;
            }
            mText += `
                </ul>
            </div>`;
            
            let pText=`
                <div class="header-serach__hints-right">
                <span class="header-serach__hints-heading">${input.dataset.products}</span>
                <div class="">`;
            for(let i=0; i<products.productList.length; i++){ 
                pText += `
                <a href="/search-redirect.php?id=${products.productList[i].hash}" class="search-product">
                    <div class="search-product__img">
                        <img src="${products.productList[i].image?products.productList[i].image.replace('../', '/'):'/templates/gfx/no-image.png'}" alt="">
                    </div>
                    <div class="search-product__text">
                        <span class="name">${products.productList[i].name}</span>
                        <span class="seria">${products.productList[i].symbol}</span>
                    </div>
                </a>`
                if(i==3)break;
            }
            pText += ` 
                </div>
            </div>`;
            
            const text = `
           <div class="header-serach__hints-left">
            ${cText}
            ${mText}
            
        </div>
        
        ${pText}    
               
        <a href="${input.form.action}?q=${phrase}" class="header-serach__link">${input.dataset.searchpage}</a>`

                searchHints.innerHTML = text;
                headerSearch.classList.add('active');
        };
    
        input.addEventListener('input', function (e) {
            //console.log(e);
            phrase=e.target.value;
            if (phrase == '') {
                headerSearch.classList.remove('active');
            } else {
                if(phrase.length>=minChars && e.data!=' '){
                    phrase=phrase.toLowerCase();
                    let qs='';
                    //if(products.hint.indexOf(phrase)!==0)
                        qs+='&p=1';
                    //if(categories.hint.indexOf(phrase.substring(Math.max(0, phrase.lastIndexOf(' ') + 1)))!==0)
                        qs+='&c=1';
                    //if(producers.hint.indexOf(phrase)!==0)
                        qs+='&m=1';
                    //console.log(categories.hint, phrase.substring(phrase.lastIndexOf(' ')), categories.hint.indexOf(phrase.substring(Math.max(0, phrase.lastIndexOf(' ')))));
                    if(qs!=''){
                        qs='?q=' + phrase + qs;
                        var ajax = new XMLHttpRequest();
                        ajax.onreadystatechange = function(e) {
                            if(this.readyState==4){
                                const responce=JSON.parse(ajax.responseText);
                                console.log(responce);
                                if(responce.categories.categoryList!==undefined){
                                    categories.categoryList=responce.categories.categoryList;
                                    if(responce.categories.categoryList.length>0)
                                        categories.hint=responce.categories.categoryList[0].hint.toLowerCase();
                                    else
                                        categories.hint='';
                                }
                                
                                if(responce.producers.producerList!==undefined){
                                    producers.producerList=responce.producers.producerList;
                                    if(responce.producers.producerList.length>0)
                                        producers.hint=responce.producers.producerList[0].hint.toLowerCase();
                                    else
                                        producers.hint='';
                                }
                                
                                if(responce.products.productList!==undefined){
                                    products.productList=responce.products.productList;
                                    if(responce.products.productList.length>0)
                                        products.hint=responce.products.productList[0].hint.toLowerCase();
                                    else
                                        products.hint='';
                                }
                                
                                renderList();
                            }
                        };
                        ajax.open('GET', url + qs);
                        ajax.send();
                    }
                }
                
            }

        });
    }

    document.addEventListener("click", (evt) => {
        let targetElement = evt.target;

        if (headerSearch.classList.contains('active')) {
            do {
                if (targetElement.id == 'searchHints' || targetElement.id == 'searchWord') {
                    return;
                } else
                    targetElement = targetElement.parentNode;

            } while (targetElement);

            headerSearch.classList.remove('active')
        }

    });
})(window, document);